
































import { Component, Vue } from 'vue-property-decorator';

import Typography from '@/components/atoms/Typography/Typography.vue';
import LoyaltyExample from '@/components/molecules/LoyaltyExample/LoyaltyExample.vue';
import FilledButton from '@/components/molecules/FilledButton/FilledButton.vue';
import RefundConfigForm from '@/components/organisms/RefundConfigForm/RefundConfigForm.vue';

import SingUpService from '@/api/SingupService';

import { updateRegistration } from '@/utils/updateRegistration';
import { ConfigFormData } from '@/models/onboarding';
import { configFormDataFactory } from '@/views/Onboarding/helpers';
import { validation } from '@/views/Onboarding/Steps/Refund/validation';

@Component({
  components: {
    Typography,
    RefundConfigForm,
    LoyaltyExample,
    FilledButton
  }
})
export default class RefundPolicyPage extends Vue {
  formData: ConfigFormData = configFormDataFactory();
  signUpService = new SingUpService();
  loading = false;

  get tPrefix() {
    return 'coinLoyaltySettings.refundPolicy';
  }

  get isValidForm() {
    return validation(this.formData);
  }

  get businessInfo() {
    return this.$store.getters['business/getBusinessInfo'].business;
  }

  handleChangeRefundConfig(formData: ConfigFormData) {
    this.formData = formData;

    this.$analytics({
      eventCategory: 'Coin & Loyalty Settings - Refund & Return Policy',
      eventLabel: `Clicked on each of the refund options (${
        this.formData.value
      })`,
      eventAction: 'click'
    });
  }

  async submit() {
    const { customValue, value } = this.formData;

    const payload = { refundsLimitDays: value || customValue };

    this.loading = true;

    const res = await this.signUpService.setupRules(payload);

    this.loading = false;

    if (res.status !== 200) return;

    this.$store.dispatch('business/SET_BUSINESS_INFO', {
      ...this.businessInfo,
      refundsLimitDays: res.data.refundsLimitDays,
      coinRewardPercentage: res.data.coinRewardPercentage
    });

    updateRegistration('return-policy');

    this.$notification(
      String(this.$t(`${this.tPrefix}.successNotification`)),
      'success'
    );

    this.$analytics({
      eventCategory: 'Coin & Loyalty Settings - Refund & Return Policy',
      eventLabel: `Clicked on the "Save" button`,
      eventAction: 'click'
    });
  }
}
